<template>
  <!--  노션 링크 : https://www.notion.so/NewsroomPage-375f1933e2184fe78aba40a324e584e7 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="newsroom_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">NEWSROOM</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="newsroom_body_hedaer col-md-12">
      <h2 class="text-center">
        <strong>뉴스룸</strong>
      </h2>
    </div>

    <section class="bg-light d-table w-100">
      <div class="container">
        <router-link :to="`/p/Newsroom/NewsroomDetail/${firstHeadItem.id}`">
          <div class="row align-items-center">
            <div class="col-md-6 col-12">
              <div>
                <div class="headerItem">
                  {{ firstHeadItem.title }}
                </div>
                <hr class="my-4" />
                <p class="para-desc">
                  {{ firstHeadItem.subtitle1 }}
                </p>
                <div class="mt-4 pt-2">
                  <span class="text-muted readmore"> Read More <i class="mdi mdi-chevron-right"></i> </span>
                </div>
              </div>
            </div>
            <!--end col-->

            <div class="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <img :src="firstHeadItem.image" class="img-fluid d-block mx-auto" alt="" />
            </div>
            <!--end col-->
          </div>
        </router-link>

        <!--end row-->
      </div>
      <!--end container-->
    </section>

    <div class="container mb-5">
      <div class="row">
        <div v-for="item in noHeadItems" :key="item.id" class="col-lg-4 col-md-6 mt-4 pt-2">
          <router-link :to="`/p/Newsroom/NewsroomDetail/${item.id}`">
            <div class="card blog rounded border-0 shadow">
              <div class="position-relative">
                <img :src="item.image" class="card-img-top rounded-top" alt="..." />
                <div class="overlay rounded-top bg-dark"></div>
              </div>
              <div class="card-body content">
                <h5>
                  <span class="card-title title text-dark">
                    {{ item.title }}
                  </span>
                </h5>
                <div class="post-meta d-flex justify-content-between mt-3">
                  <span class="text-muted readmore"> Read More <i class="mdi mdi-chevron-right"></i> </span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <!--end col-->
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import boardService, {BoardParam} from '@/services/board.service';
import {BOARD_ID} from '@/util/BoardConst';
import moment from 'moment';
import {BoardArticle} from '@/models';

export default {
  name: 'NewsroomPage',
  components: {Breadcrumb},
  data() {
    return {
      items: [],
      newsroom_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'ABOUT',
        present: '뉴스룸',
      },
    };
  },
  async created() {
    // {
    //   id: 0,
    //   title: '국내 최고 골프장에 선정된 핀크스 골프클럽',
    //   date: '2021-12-31',
    //   image: 'main_newsroom_sample01.jpg',
    // },

    const aList = await boardService.getArticleListObjParam(new BoardParam(BOARD_ID.BID_PLEISURE_NEWSROOM));

    //console.log(aList);

    this.items = aList.map(x => ({
      id: x.id,
      title: x.title,
      date: moment(x.startDate).format('YYYY-MM-DD'),
      image: x.getFirstAttachFileUrl(true),
      isHead: x.isHead,
    }));
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: '뉴스룸'});
  },
  computed: {
    firstHeadItem() {
      const heads = this.items.filter(x => x.isHead);
      if (heads.length > 0) return heads[0];
      else if (this.items.length > 0) return this.items[0];
      else return {};
    },

    noHeadItems() {
      return this.items.filter(x => !x.isHead);
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
    word-break: keep-all;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/common/newsroom_headerimage.jpg');
}

.headerItem {
  font-weight: bold;
  font-size: 2rem;
  word-break: keep-all;
}
.card-title {
  font-size: 1rem;
  word-break: keep-all;
}
@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
}

h2 {
  padding-top: 3rem;
  padding-bottom: 3rem;
  height: 8rem;
  text-align: center;
  color: #222222;
  //font-family: 'Nanum Gothic', sans-serif;
  //font-family: 'Jeju Myeongjo', sans-serif;
  font-weight: 700;
  //font-size: 1.6em !important;
}
::v-deep {
  a {
    color: black;
  }
}
</style>
